.profileBtn {
    &:hover,
    &:focus,
    &[data-menu-open="true"] {
        background-color: var(--mantine-color-dark-5);
    }
}

.versionText {
    align-items: center;
    display: flex;
    font-weight: 400;
    margin-left: 0.25rem;
    margin-top: 0.25rem;
    margin-bottom: 0 !important;
    color: var(--mantine-color-dark-3);
}
